import React from 'react';
import classes from './SocialShare.css';

import {
    FacebookShareButton,
    WeiboShareButton,
    LinkedinShareButton,
    TwitterShareButton,
}   from "react-share";

import {
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WeiboIcon,
}   from "react-share";

class SocialShare extends React.Component{

    render(){

        let shareUrl = this.props.shareUrl;
        let shareTitle = this.props.shareTitle;
        let shareSize = 40;
        let shareBorderRadius = 8;
        let shareRound = false;
        return (
            <div>
                
            <FacebookShareButton url={shareUrl} quote={shareTitle} className={classes.SocialShareButton}>
                <FacebookIcon size={shareSize} round={shareRound} borderRadius={shareBorderRadius}/>
            </FacebookShareButton>

            <LinkedinShareButton 
                url={shareUrl} 
                title={shareTitle} 
                summary="Let's make a call for chitchat! Please go to my calendar and book a time."
                source="BookMeeY"
                className={classes.SocialShareButton}>
                <LinkedinIcon size={shareSize} round={shareRound} borderRadius={shareBorderRadius}/>
            </LinkedinShareButton>

            <TwitterShareButton 
                url={shareUrl}
                title={shareTitle}
                hashtags={["BookMeeY", "Friends"]}
                className={classes.SocialShareButton}>
                <TwitterIcon size={shareSize} round={shareRound} borderRadius={shareBorderRadius}/>
            </TwitterShareButton>

            <WeiboShareButton 
                url={shareUrl}
                title={shareTitle}
                image="https://www.bookmeey.com/favicon.ico"
                className={classes.SocialShareButton}>
                <WeiboIcon size={shareSize} round={shareRound} borderRadius={shareBorderRadius}/>
            </WeiboShareButton>

            </div>
                        
        );
    }
}

export default SocialShare;


// WEBPACK FOOTER //
// ./src/components/SocialShare/SocialShare.js